import * as actionTypes from './actionTypes';

export const requestLoadWorkoutEvents = ({ params, userId }) => ({
  type: actionTypes.REQUEST_LOAD_WORKOUT_EVENTS,
  params,
  userId,
});

export const requestCreateWorkoutEvents = ({
  isNow,
  userId,
  payload,
  callbacks,
}) => ({
  type: actionTypes.REQUEST_CREATE_WORKOUT_EVENTS,
  payload,
  userId,
  isNow,
  callbacks,
});

export const requestLoadFullWorkoutEvent = ({ id }) => ({
  type: actionTypes.REQUEST_LOAD_FULL_WORKOUT_EVENT,
  id,
});

export const requestCreateWorkoutEventResult = ({
  items,
  eventId,
  workoutExerciseId,
}): EntityAction => ({
  type: actionTypes.REQUEST_CREATE_WORKOUT_EVENT_RESULT,
  items,
  eventId,
  workoutExerciseId,
});

export const requestRemoveAllEventResults = (
  eventId: number,
): EntityAction => ({
  type: actionTypes.REQUEST_REMOVE_ALL_EVENT_RESULTS,
  eventId,
});

export const requestFinishEvent = (
  eventId: number,
  callbacks,
): EntityAction => ({
  type: actionTypes.REQUEST_FINISH_EVENT,
  eventId,
  callbacks,
});
